import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { ToastrService } from 'ngx-toastr';
import { Subscription, fromEvent, filter, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { VendorList } from 'src/app/service/customer.model';
import { FilesService } from 'src/app/service/files.service';
import { FilterVendorViewModel } from 'src/app/service/filterData.model';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { CityViewModel } from 'src/app/service/state.model';
import { environment } from 'src/environments/environment';
import { Constant, NumberOfEntriesToShow, PriorityList, RoleName, TransportTypes } from '../../@shared/constants/Constant';
import { VendorService } from '../../service/vendor.service';
import { BusinessUnit } from './../../service/business-unit';
import { ViewFilesModalComponent } from '../v2/components/view-files-modal/view-files-modal.component';
import { MatDialog } from '@angular/material/dialog';

declare var $: any;

@Component({
  selector: 'app-manage-vendor',
  templateUrl: './manage-vendor.component.html',
  styleUrls: ['./manage-vendor.component.css'],
})
export class ManageVendorComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInput: ElementRef;
  private _subscriptions: Subscription = new Subscription();
  public sortBy: string = 'name'; //Reference in template file
  public sortOrder: boolean = false; //Reference in template file
  public pageNumber: number = 1;
  public selectedPage: number = 10;
  public totalCount: number; //Reference in template file
  public pagination: string;
  public searchText: string = ''; //Reference in template file
  public searchText1: string; //Reference in template file
  public vehicleImag: true; //Reference in template file
  public responsive: boolean; //Reference in template file
  public vendorDetail: BusinessUnit; //Reference in template file
  public numberOfEntries: number[] = NumberOfEntriesToShow; //Reference in template file
  public transportList = TransportTypes; //Reference in template file
  public priorityList = PriorityList; //Reference in template file
  vendorList$: Observable<VendorList[]>;
  public limit: number;
  public currentPage: number = 1;
  public vendorListNames: VendorList[] = [];
  public cityDataModel = {
    cityList: [] as CityViewModel[],
    cityDropdownSettings: {
      singleSelection: false,
      idField: 'id',
      textField: 'cityName',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    },
    selectedAreas: [] as CityViewModel[],
  };
  vendorDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  public dropDownSettingsForTransportAndPriority = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  vendors: BusinessUnit[] = [];

  constructor(
    private _fileService: FilesService,
    private vendorService: VendorService,
    private _toast: ToastrService,
    private _serviceRequestService: ServiceRequestService,
    private readonly dialog: MatDialog,
  ) {}

  public user: ILoggedInUserViewModel;
  public loader: boolean = true;
  public isInternalReadOnly: boolean = false;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this.getVendorList();
    this.getCityList();
    this.getVendorListNames();
    this.isMobileDevice = mobileDeviceCheck();
  }

  ngAfterViewInit(): void {
    this.searchVendor();
  }

  getVendorListNames(): void {
    this.vendorList$ = this.vendorService.getFilteredVendorsList();
  }

  searchVendor() {
    const searchInput = document.getElementById('search-filter');
    if (searchInput) {
      fromEvent(searchInput, 'input')
        .pipe(debounceTime(1000))
        .subscribe((searchTextResponse) => {
          this.currentPage = 1;
          this.dataFilter = {
            vendorName: this.selectedVendors.map((y) => y.name),
            city: this.cityDataModel.selectedAreas.map((y) => y.cityName),
            transportType: this.selectedTransports.map((y) => y.name),
            priority: this.selectedPriorities.map((y) => y.id),
            isShowAllBusinessUnit: this.dataFilter.isShowAllBusinessUnit,
            searchString: (searchTextResponse.target as HTMLInputElement).value.trim() || '',
            limit: this.selectedPage,
            offsetvalue: this.currentPage,
          };
          this.getVendorsListDetails();
        });
    }
  }

  private getVendorsListDetails() {
    this.loader = true;
    this._subscriptions.add(
      this.vendorService.getFilterData(this.dataFilter).subscribe(
        (response) => {
          this.vendors = response.businessUnitInfos;
          this.totalCount = response.count;
          this.pagination = Constant.showPaginationMessage(this.totalCount, this.currentPage, this.selectedPage);
          this.loader = false;
        },
        (error) => {
          this.loader = false;
          this._toast.warning('Something went wrong! Please try again', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      ),
    );
  }

  getVendorList() {
    this.loader = true;
    this.dataFilter = {
      vendorName: this.selectedVendors.map((y) => y.name),
      city: this.cityDataModel.selectedAreas.map((y) => y.cityName),
      transportType: this.selectedTransports.map((y) => y.name),
      priority: this.selectedPriorities.map((y) => y.id),
      isShowAllBusinessUnit: this.dataFilter.isShowAllBusinessUnit,
      searchString: this.searchText,
      limit: this.selectedPage,
      offsetvalue: this.currentPage,
    };
    this.getVendorsListDetails();
  }

  updateVendorList(): void {
    this.cleanSearchedData();
    this.getVendorListNames();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  public isMobileDevice: boolean = true;

  getCityList() {
    this._subscriptions.add(
      this.vendorService.getCityList().subscribe((response) => {
        this.cityDataModel.cityList = response;
        this.cityDataModel.cityList = this.cityDataModel.cityList.filter((city) => city.cityName != '');
      }),
    );
  }

  public baseUrl: string = `${environment.baseUrl}`; //Reference in template file
  public modalHeader: string;
  public selectedIndex: string;
  public isVehicleCreated: boolean;

  openEditVendorModel(vendorDetail: BusinessUnit) {
    this.isVehicleCreated = vendorDetail.isVehicleCreated;
    this._subscriptions.add(
      this._fileService.fetchFiles('Vendor', vendorDetail.businessUnitId).subscribe((response) => {
        this.chooseFile = response.items;
        this.chooseFile.forEach((file) => {
          file.fileName = file.displayName.split('.')[0];
          file.fileType = file.displayName.split('.')[1];
        });
      }),
    );
    this.vendorDetail = vendorDetail;
    this.modalHeader = 'Edit';
    this.isModelOpen = true;
  } //Reference in template file

  public isModelOpen = false;

  openAddVendor() {
    this.chooseFile = [];
    this.modalHeader = 'Add';
    this.isModelOpen = true;
  } //Reference in template file

  public selectedVendors: VendorList[] = [];
  public selectedTransports = [];
  public selectedPriorities = [];

  public dataFilter: FilterVendorViewModel = {
    vendorName: [],
    city: [],
    priority: [],
    transportType: [],
    isShowAllBusinessUnit: false,
    searchString: '',
    limit: 10,
    offsetvalue: 1,
  };

  currentPageChange() {
    this.getVendorList();
  }

  changeToggle(event, vendorDetail: BusinessUnit) {
    this.loader = true;
    this._subscriptions.add(
      this.vendorService.getVendorDetailEnable(event.target.checked, vendorDetail.businessUnitId).subscribe((response) => {
        this.getVendorList();
      }),
    );
  } //Reference in template file

  cleanSearchedData() {
    this.dataFilter = {
      vendorName: [],
      city: [],
      priority: [],
      transportType: [],
      isShowAllBusinessUnit: false,
      searchString: '',
      limit: 10,
      offsetvalue: 1,
    };
    this.currentPage = 1;
    this.cityDataModel.selectedAreas = [];
    this.selectedTransports = [];
    this.selectedVendors = [];
    this.searchText = '';
    this.selectedPriorities = [];
    this.getVendorsListDetails();
  } //Reference in template file

  public popupFilterFileType: string[];
  public index: number;

  openUploadedFile(id: string): void {
    this.dialog
      .open(ViewFilesModalComponent, {
        width: '900px',
        panelClass: 'no-padding',
        data: {
          serviceRequestId: id,
          fromPage: 'Vendor',
          isTagRequired: true,
          isFileEditable: true,
        },
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.selectedPage = 1;
        this.getVendorsListDetails();
      });
  }

  modelClose() {
    this.isModelOpen = false;
  } //Reference in template file

  public chooseFile = [];

  showAllVendor() {
    this.dataFilter.isShowAllBusinessUnit = !this.dataFilter.isShowAllBusinessUnit;
    this.pageNumber = 1;
    this.getVendorList();
    this.pagination = Constant.showPaginationMessage(this.vendors.length, this.pageNumber, this.selectedPage);
  } //Reference in template file

  selectChange(event) {
    this.loader = true;
    this.pageNumber = 1;
    this.selectedPage = event.target.value;
    this.getVendorList();
  } //Reference in template file

  public multipleFileUpload: FormData;
  public path: string = '';
  public deletedFile = [];

  toggleMoreAction(name, id) {
    $('#' + name + id).toggleClass('d-none');
  } //Reference in template file

  //sorting;
  public name: boolean = false; //Reference in template file
  public stateName: boolean = false; //Reference in template file
  public streetAddress: boolean = false; //Reference in template file
  public phoneNumber: boolean = false; //Reference in template file
  public emailID: boolean = false; //Reference in template file
  public transportType: boolean = false; //Reference in template file
  public priority: boolean = false; //Reference in template file
  public isContracted: boolean = false; //Reference in template file
}
